//モーダル系JS

$(function(){
  //init
  ingredientModal();
  productTagInfo();


  //食材モーダル
  function ingredientModal() {
    $('.js-modal-inline').magnificPopup({
      type: 'inline',
      preloader: false,
      showCloseBtn: false,
      closeOnBgClick: false,
    });

    //閉じるリンクの設定
    $('.js-modal-close').on('click', function(e){
      e.preventDefault();
      $.magnificPopup.close();
    });

    //前へ
    $('.c-ingredients__modal-control--prev > a').on('click', function(e){
      let target = $(this).attr('href');

      e.preventDefault();
      $.magnificPopup.close();
      makeModal(target);
    });

    //次へ
    $('.c-ingredients__modal-control--next > a').on('click', function(e){
      let target = $(this).attr('href');

      e.preventDefault();
      $.magnificPopup.close();
      makeModal(target);
    });
  }

  //プロダクト一覧のタグ説明
  function productTagInfo() {
    $('.p-productArchive__tagInfoBtn').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      preloader: false,
      showCloseBtn: false,
      closeOnBgClick: false,
    });

    //閉じるリンクの設定
    $('.p-productArchive__tagInfo__dismiss').on('click', function(e){
      e.preventDefault();
      $.magnificPopup.close();
    });
  }

  //モーダル作成のみ
  function makeModal(target) {
    $.magnificPopup.open({
      items: {src: target},
      type: 'inline',
      modal: true,
    });
  }


});